(function () {
  const root = document.documentElement;
  const WIDE_LAYOUT_MIN_WIDTH = 1100;

  let fullscreenBtn = null;
  let mainBlock = null;
  let contentRow = null;
  let filtersContainer = null;

  function isPortraitMobile() {
    if (!root.classList.contains('desktop4-scaled-page') ||
      !root.classList.contains('desktop4-portrait-accepted')) {
      return false;
    }
    const portrait = window.matchMedia
      ? window.matchMedia('(orientation: portrait)').matches
      : window.innerHeight >= window.innerWidth;
    return portrait && window.innerWidth < WIDE_LAYOUT_MIN_WIDTH;
  }

  function placeInRow() {
    if (fullscreenBtn.parentElement !== filtersContainer) {
      filtersContainer.appendChild(fullscreenBtn);
    }
  }

  function placeAtHome() {
    const fullscreenHome = fullscreenBtn.parentElement === mainBlock &&
      fullscreenBtn.nextElementSibling === contentRow;
    if (!fullscreenHome) {
      mainBlock.insertBefore(fullscreenBtn, contentRow);
    }
  }

  function applyPlacement() {
    if (!fullscreenBtn || !mainBlock || !contentRow || !filtersContainer) {
      return;
    }
    if (isPortraitMobile()) {
      placeInRow();
    } else {
      placeAtHome();
    }
  }

  function init() {
    mainBlock = document.getElementById('main-block');
    if (!mainBlock) {
      return;
    }
    fullscreenBtn = mainBlock.querySelector('.fullscreen-toggle');
    filtersContainer = mainBlock.querySelector('.filters-container');
    contentRow = mainBlock.querySelector('.content-row');
    if (!fullscreenBtn || !filtersContainer || !contentRow) {
      return;
    }
    applyPlacement();
    window.addEventListener('resize', applyPlacement);
    window.addEventListener('orientationchange', applyPlacement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
